"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unknownTypeMessage = exports.PRODUCT_LISTING_PAGE = exports.NO_CONTENT_ITEMS_FOUND_MESSAGE = void 0;
const PRODUCT_LISTING_PAGE = exports.PRODUCT_LISTING_PAGE = 'product-listing-page';
const NO_CONTENT_ITEMS_FOUND_MESSAGE = exports.NO_CONTENT_ITEMS_FOUND_MESSAGE = 'No contentItems found in editorialPage data';
const unknownTypeMessage = (typeName)=>"Unknown type name: ".concat(typeName);
exports.unknownTypeMessage = unknownTypeMessage;
